module.exports = {
      id: "triangle-right-usage",
      viewBox: "0 0 43 64",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#triangle-right",
      toString: function () {
        return this.url;
      }
    }